"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamRepository = void 0;
const pino_1 = __importDefault(require("pino"));
const appConstants_1 = require("../constants/appConstants");
const httpRepository_1 = __importDefault(require("./httpRepository"));
const userRepository_1 = __importDefault(require("./userRepository"));
const logger = (0, pino_1.default)();
const TEAMS_BATCH_SIZE = 10;
exports.TeamRepository = {
    createTeam: async ({ teamName }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post('/rest/teams', {
            teamName,
        });
        return response.data;
    },
    getAllTeams: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/teams');
        return response.data;
    },
    getTeamsPage: async (params) => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/teams', {
            params,
        });
        return response.data;
    },
    getAllTeamsData: async ({ state }) => {
        let result = [];
        let page = 0;
        let totalCount = null;
        const params = state ? { state } : {};
        params.limit = TEAMS_BATCH_SIZE;
        while (page === 0 || (totalCount != null && page * params.limit < totalCount)) {
            const teamsPage = await exports.TeamRepository.getTeamsPage({ ...params, offset: page * params.limit });
            result = [...result, ...teamsPage];
            page = page + 1;
            if (totalCount === null) {
                totalCount = (teamsPage && teamsPage[0] && teamsPage[0].teamsCount) || 0;
            }
        }
        return result;
    },
    getTeams: async ({ state, limit, page }) => {
        const params = state ? { state } : {};
        if (Number.isInteger(limit) && Number.isInteger(page) && limit != null && limit > 1 && page != null && page >= 0) {
            params.limit = limit;
            params.offset = limit * page;
            return exports.TeamRepository.getTeamsPage(params);
        }
        else {
            if (!state) {
                return;
            }
            return exports.TeamRepository.getAllTeamsData({ state });
        }
    },
    getTeam: async ({ teamId }) => {
        try {
            const teamID = typeof teamId === 'object' ? (Array.isArray(teamId) ? teamId?.[0] : teamId.teamId) : teamId;
            const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamID}`);
            return response.data;
        }
        catch (error) {
            logger.error('Error getting team', error);
            return {};
        }
    },
    getReport: async (path) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(path);
        return response;
    },
    getTeamProperty: async ({ teamId, propertyKey }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/properties/${propertyKey}`);
        return response.data;
    },
    saveTeamName: async ({ teamId, teamName }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/updateName`, {
            teamName,
        });
        return response.data;
    },
    saveTeamProperty: async ({ teamId, propertyKey, propertyValue, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/properties/${propertyKey}`, { propertyValue });
        return response.data;
    },
    activateTeam: async (teamId) => {
        await httpRepository_1.default.tradeshiftGo().post(`/rest/teams/${teamId}/activate`);
    },
    deactivateTeam: async (teamId) => {
        await httpRepository_1.default.tradeshiftGo().post(`/rest/teams/${teamId}/deactivate`);
    },
    getTeamUsers: async (teamId, query) => {
        if (!teamId) {
            throw new Error('TeamId is required');
        }
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/users${query}`);
        return response.data;
    },
    setUserTeamProperty: async (userId, teamId, propertyKey, propertyValue) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/users/${userId}/properties/${propertyKey}`, { propertyValue });
        return response.data;
    },
    getDecoratedUser: async ({ teamId, userId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/users/${userId}`);
        return response.data;
    },
    removeUserFromTeam: async (teamId, userId) => {
        return httpRepository_1.default.tradeshiftGo().delete(`/rest/teams/${teamId}/users/${userId}`);
    },
    getCurrencies: async (teamId) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/currencies`);
        return response.data;
    },
    getUserTeamProperties: async ({ userId, teamId }) => {
        if (!userId) {
            const user = await userRepository_1.default.getUser();
            userId = user?.userId;
        }
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/users/${userId}/properties`);
        return response.data;
    },
    getOooSettings: async ({ userId, teamId }) => {
        if (!userId) {
            const user = await userRepository_1.default.getUser();
            userId = user?.userId;
        }
        const properties = await exports.TeamRepository.getUserTeamProperties({ userId, teamId });
        const outOfOfficeKeys = Object.values(appConstants_1.userTeamProperties.outOfOffice);
        return properties.reduce((output, property) => {
            const propertyKey = Object.keys(property)[0];
            if (propertyKey && outOfOfficeKeys.includes(propertyKey)) {
                output[propertyKey] = property[propertyKey];
            }
            return output;
        }, {});
    },
    setUserTeamProperties: async ({ userId, teamId, properties, }) => {
        if (!userId) {
            const user = await userRepository_1.default.getUser();
            userId = user?.userId;
        }
        return httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/users/${userId}/properties`, { properties });
    },
};
